export const atsUtils = {
  getStatusColor: (status) => {
    const colors = {
      applied: "gray",
      screening: "blue",
      interview_1: "purple",
      interview_2: "teal",
      assessment: "cyan",
      offer_pending: "orange",
      offer_accepted: "green",
      hired: "green",
      rejected: "red",
      withdrawn: "gray",
      // Requisition status colors
      draft: "gray",
      pending_approval: "orange",
      approved: "green",
      on_hold: "yellow",
      closed: "red",
      cancelled: "gray",
    };
    return colors[status] || "gray";
  },

  formatApplicationStatus: (status) => {
    const labels = {
      applied: "Applied",
      screening: "Resume Screening",
      interview_1: "First Interview",
      interview_2: "Second Interview",
      assessment: "Assessment",
      offer_pending: "Offer Pending",
      offer_accepted: "Offer Accepted",
      hired: "Hired",
      rejected: "Rejected",
      withdrawn: "Withdrawn",
      // Requisition status labels
      draft: "Draft",
      pending_approval: "Pending Approval",
      approved: "Approved",
      on_hold: "On Hold",
      closed: "Closed",
      cancelled: "Cancelled",
    };
    return labels[status] || status;
  },

  getRequisitionPriority: (priority) => {
    const colors = {
      low: "gray",
      medium: "yellow",
      high: "orange",
      urgent: "red",
    };
    return colors[priority] || "gray";
  },
};

export default atsUtils;
